import request from '@/utils/server'
 


  // 列表
  export function getBiddingMaterials(query) {
    return request({
      url: '/procurement/getBiddingMaterials',
      method: 'get',
     params: query
    })
  }
//   供应商报价
 export function supplierBidding(data) {
    return request({
      url: '/procurement/pc/Bidding',
      method: 'post',
    data:data
    })
}
// 查看报价
  export function getBiddingByPid(query) {
    return request({
      url: '/procurement/getBiddingByPid',
      method: 'get',
     params: query
    })
  }
//  